import React from "react";

export default function About() {
  return (
    <section id="about">
      <div className="lg:px-40 container mx-auto flex px-10 py-12 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white mt-0">
            Hi, I'm Nat.
            <br className="hidden lg:inline-block" /> I'm a designer and
            self-taught developer.
          </h1>
          <p className="mb-8 leading-relaxed">
            Architectural degree graduated designer, self-taught frontend developer
            with art and design background.
          </p>
          <div className="flex justify-center">
            <a
              href="https://www.linkedin.com/in/tiranat-kamklai-51a4b951/"
              target="_blank"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-sm"
            >My LinkedIn
            </a>
            <a
              href="https://medium.com/@tiranat"
              target="_blank"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-sm"
            >My Blogs
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center rounded"
            alt="NatTK"
            src="https://res.cloudinary.com/dxj2cymt8/image/upload/v1677316889/tk0779githubio/NatTK_Illus_magnph.png"
          />
        </div>
      </div>
    </section>
  );
}
